import { Notify } from "@digitallab/grid-common-frontend-components";

export const notifyDbMismatch = (reason) => {
  Notify({
    type: "error",
    title: "",
    text: `DB Mismatch, please raise ticket : ${reason}`
  });
};
